<template>
  <div>
    <div style="border: 1px solid #eeeeee;margin-bottom: 12px;padding: 8px">
      <div>
        <text-group :label="'利用したエージェント名'"
                    v-bind:val="review_agent.agent_name"
                    v-model="review_agent.agent_name"
                    :require="true"></text-group>

        <text-group :label="'エージェントの満足度'"
                    :require="true">
          <template slot="text">
            <review-evaluation-type1 :rank.sync="review_agent.rank_good_reward" class="mod_listbox" :title="false">
              <template slot="rank1">低い</template>
              <template slot="rank2">やや低い</template>
              <template slot="rank3">普通</template>
              <template slot="rank4">やや高い</template>
              <template slot="rank5">高い</template>
            </review-evaluation-type1>
          </template>
        </text-group>

        <text-group :label="'エージェントの満足・不満足な点'"
                    :require="true">
          <template slot="text">
            <textarea class="form-control" rows="5" v-model="review_agent.agent_review"></textarea>
          </template>
          <template slot="line"></template>
        </text-group>
        <div>
          <label><input type="checkbox" value="1" v-model="checked">他にも利用したことがある</label>
          <label class="radio side" @click="$emit('delete', index)" v-if="index>0">削除</label>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ReviewEvaluationType1 from '@/components/review/form/EvaluationType1'

  export default {
    components: {
      ReviewEvaluationType1
    },
    props: {
      review_agent: {
        default: function () {
          return {}
        }
      },
      disable_check: {
        default: false
      },
      index: {
        default: 0
      },
      readonly: {
        default: false
      }
    },
    data: function () {
      return {
        id: 'agent_' + this._uid + '_check',
        checked: ''
      }
    },
    watch: {
      review_agent: {
        deep: true,
        handler: function () {
          window.console.log(this.review_agent)
          this.$emit('update:review_agent', this.review_agent)
        }
      },
      checked: {
        handler: function () {
          if (this.checked) {
            this.$emit('append')
          } else {
            this.$emit('delete', this.index + 1)
          }
          if (this.force_check) {
            this.checked = true
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Agent.vue?c2f3774a